module.exports = __webpack_public_path__ + "google-play-badge.svg?5e01637f08de80e8c27c414687738968";